var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"calc(100vh - 280px)"}},[_c('div',{staticClass:"d-flex alternative-main-text pa-4"},[_vm._v(_vm._s(_vm.$t('alternative_text')))])])}
var staticRenderFns = []

export { render, staticRenderFns }